(function(){
  function onReady(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, {once:true});
    else fn();
  }

  var miniFrame = 0;

  function scheduleMinicartUpdate(){
    if(miniFrame) return;
    miniFrame = window.requestAnimationFrame(function(){
      miniFrame = 0;
      var body = document.body;
      var drawer = document.querySelector('#dropdnMinicartPopup .minicart-drop');
      var open = false;

      if(drawer){
        var style = window.getComputedStyle(drawer);
        if(style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) !== 0){
          var rect = drawer.getBoundingClientRect();
          open = rect.width > 10 && rect.height > 10 && rect.right > 0 && rect.left < window.innerWidth && rect.bottom > 0 && rect.top < window.innerHeight;
        }
      }

      if(body && body.classList.contains('drops-minicart-open') !== open){
        body.classList.toggle('drops-minicart-open', open);
      }
    });
  }

  function bindMinicartObserver(){
    var popup = document.querySelector('#dropdnMinicartPopup');
    if(!popup){
      scheduleMinicartUpdate();
      return;
    }

    if(!popup.__dropsMinicartObserver){
      var observer = new MutationObserver(scheduleMinicartUpdate);
      observer.observe(popup, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class','style','open','aria-hidden']
      });
      popup.__dropsMinicartObserver = observer;
    }

    scheduleMinicartUpdate();
  }

  function bindHeaderSearch(root){
    (root || document).querySelectorAll('[data-drops-header-search]').forEach(function(form){
      if(form.__dropsBound) return;
      form.__dropsBound = true;
      form.addEventListener('submit', function(event){
        var select = form.querySelector('[data-category-select]');
        var input = form.querySelector('input[name="q"]');
        if(select && select.value && input && !input.value.trim()){
          event.preventDefault();
          window.location.href = select.value;
        }
      });
    });
  }

  function init(root){
    bindHeaderSearch(root || document);
    bindMinicartObserver();
  }

  onReady(function(){
    init(document);
    window.addEventListener('resize', scheduleMinicartUpdate, {passive:true});
    document.addEventListener('click', function(){
      bindMinicartObserver();
      scheduleMinicartUpdate();
    }, {passive:true});
    document.addEventListener('cart:updated', function(){
      bindMinicartObserver();
      scheduleMinicartUpdate();
    });
    document.addEventListener('shopify:section:load', function(event){
      init(event.target);
    });
  });
})();

(function(){
  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, {once:true});
    else fn();
  }

  function setupSticky(bar){
    if(!bar || bar.__dropsStickyBound) return;
    bar.__dropsStickyBound = true;

    var marker = document.querySelector('.js-sticky-add-to-cart-marker');
    var footer = document.querySelector('.drops-footer, footer');
    var qtyInput = bar.querySelector('[data-drops-sticky-qty]');
    var addButton = bar.querySelector('[data-drops-sticky-add]');
    var closed = false;
    var markerVisible = !!marker;
    var frame = 0;

    function setVisible(){
      var shouldShow = !closed && !markerVisible && window.scrollY > 220;
      if(bar.classList.contains('is-visible') !== shouldShow){
        bar.classList.toggle('is-visible', shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }
      return shouldShow;
    }

    function avoidFooter(){
      if(!footer || !bar.classList.contains('is-visible')){
        if(bar.style.bottom) bar.style.bottom = '';
        return;
      }
      var rect = footer.getBoundingClientRect();
      var overlap = window.innerHeight - rect.top;
      var nextBottom = overlap > 0 ? (overlap + 22) + 'px' : '';
      if(bar.style.bottom !== nextBottom) bar.style.bottom = nextBottom;
    }

    function update(){
      frame = 0;
      setVisible();
      avoidFooter();
    }

    function schedule(){
      if(frame) return;
      frame = window.requestAnimationFrame(update);
    }

    if(marker && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        markerVisible = entries[0].isIntersecting;
        schedule();
      }, {threshold:.1}).observe(marker);
    }else{
      markerVisible = false;
    }

    var closeButton = bar.querySelector('[data-drops-sticky-close]');
    if(closeButton){
      closeButton.addEventListener('click', function(){
        closed = true;
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden','true');
        bar.style.bottom = '';
      });
    }

    var minusButton = bar.querySelector('[data-drops-sticky-minus]');
    if(minusButton && qtyInput){
      minusButton.addEventListener('click', function(){
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value,10) || 1) - 1);
      });
    }

    var plusButton = bar.querySelector('[data-drops-sticky-plus]');
    if(plusButton && qtyInput){
      plusButton.addEventListener('click', function(){
        qtyInput.value = (parseInt(qtyInput.value,10) || 1) + 1;
      });
    }

    function currentVariantId(){
      var candidates = document.querySelectorAll('form[action*="/cart/add"] input[name="id"], product-form input[name="id"]');
      for(var i=0;i<candidates.length;i++){
        if(!candidates[i].closest('[data-drops-single-sticky]') && candidates[i].value) return candidates[i].value;
      }
      return bar.getAttribute('data-current-variant');
    }

    if(addButton && qtyInput){
      addButton.addEventListener('click', async function(){
        if(addButton.disabled) return;
        var variantId = currentVariantId();
        var quantity = Math.max(1, parseInt(qtyInput.value,10) || 1);
        if(!variantId) return;

        var oldText = addButton.textContent;
        addButton.disabled = true;
        addButton.textContent = 'Adding…';

        try{
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var response = await fetch(root + 'cart/add.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:Number(variantId), quantity:quantity}]})
          });
          if(!response.ok) throw new Error('Unable to add item');

          addButton.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated', {bubbles:true}));
          setTimeout(function(){ window.location.reload(); }, 500);
        }catch(error){
          addButton.disabled = false;
          addButton.textContent = 'Try again';
          setTimeout(function(){ addButton.textContent = oldText; }, 1800);
        }
      });
    }

    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    schedule();
  }

  function init(root){
    var scope = root || document;
    if(scope.matches && scope.matches('[data-drops-single-sticky]')) setupSticky(scope);
    var bar = scope.querySelector ? scope.querySelector('[data-drops-single-sticky]') : null;
    if(bar) setupSticky(bar);
  }

  ready(function(){
    init(document);
    document.addEventListener('shopify:section:load', function(event){
      init(event.target);
    });
  });
})();

// DROPS_PRODUCT_NAV_FIX_V1
(function(){
  'use strict';

  document.addEventListener('click', function(event){
    if(
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) return;

    var target = event.target;
    var link = target && target.closest
      ? target.closest('product-card a[data-url][href], .prd a[data-url][href]')
      : null;

    if(!link) return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch(e) {
      return;
    }

    if(url.origin !== window.location.origin) return;

    var productIndex = url.pathname.indexOf('/products/');
    if(productIndex === -1) return;

    if(productIndex > 0){
      url.pathname = url.pathname.slice(productIndex);
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if(window.DropsPageLoader && typeof window.DropsPageLoader.show === 'function'){
      window.DropsPageLoader.show();
    }

    window.location.assign(url.href);
  }, true);
})();

// DROPS_FOOTER_CAREERS_LINK_V1
(function(){
  function addCareersLink(root){
    var scope = root || document;
    var support = scope.querySelector && scope.querySelector('.df5__col[aria-label="Support"]');
    if(!support) support = document.querySelector('.df5__col[aria-label="Support"]');
    if(!support || support.querySelector('a[href*="/pages/careers"]')) return;

    var link = document.createElement('a');
    link.href = '/pages/careers';
    link.innerHTML = 'Careers <i>›</i>';

    var contact = support.querySelector('a[href*="/pages/contact"]');
    if(contact) support.insertBefore(link, contact);
    else support.appendChild(link);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ addCareersLink(document); }, {once:true});
  } else {
    addCareersLink(document);
  }

  document.addEventListener('shopify:section:load', function(event){
    addCareersLink(event.target);
  });
})();
